import { ApiConnector, GET, POST, PUT, DELETE } from './bank-request.service';

export default (() => {
    const API = ApiConnector('/report');
    return {
        GetProductsStock: async () => await API(GET, '/products/franch').call(),
        DownloadDocument: async fileName =>
            await API(GET, `/download/${fileName}`, false).call(false, false, false, 'blob'),
        GetActiveOrdersReport: async data => await API(POST, '/orders/active').call(data),
        GetTeachersReport: async (params) => 
            await API(GET, '/teachers/report', false, params).call(),
    };
})();
